'use client';

import { Button, ButtonProps } from '@mui/material';
import { clsx } from 'clsx';
import { motion } from 'motion/react';
export const EmptyState = ({
  title,
  description,
  illustration,
  illustrationBackground = 'muted',
  primaryButton,
  secondaryButton
}) => {
  const hasPrimaryButton = Object.keys(primaryButton ?? {}).length > 0;
  const hasSecondaryButton = Object.keys(secondaryButton ?? {}).length > 0;
  const hasActions = hasPrimaryButton || hasSecondaryButton;
  return <motion.div className="flex w-full flex-col items-center justify-center gap-4 px-4 py-10 text-center" initial={{
    opacity: 0,
    y: 6
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.2,
    ease: 'easeOut'
  }}>
            {illustration && <div className={clsx('flex items-center justify-center rounded-full', illustrationBackground === 'strong' ? 'bg-[color-mix(in_srgb,var(--foreground)_6%,var(--muted))]' : 'bg-muted', 'size-24 sm:size-28 md:size-32 lg:size-36 p-4 sm:p-5 md:p-6 lg:p-8')}>
                    <img src={illustration.src} alt={illustration.alt} className="object-contain" />
                </div>}

            <div className="flex max-w-md flex-col items-center gap-1">
                <h3 className="text-2xl font-medium text-foreground">{title}</h3>
                <p className="text-sm text-foreground-muted leading-relaxed!">{description}</p>
            </div>

            {hasActions && <div className="mt-2 flex flex-wrap items-center justify-center gap-2.5">
                    {hasSecondaryButton && <Button variant="contained" color="neutral" disableElevation {...secondaryButton} />}
                    {hasPrimaryButton && <Button variant="contained" color="sanya-primary" disableElevation {...primaryButton} />}
                </div>}
        </motion.div>;
};